import SchedulePage from "./SchedulePage";

export default [
    {
        path: "/",
        name: "schedule",
        component: SchedulePage
    }
]
